
import dayjs from "dayjs";

const dayMappingBM = {
  Sunday: "Ahad",
  Monday: "Isnin",
  Tuesday: "Selasa",
  Wednesday: "Rabu",
  Thursday: "Khamis",
  Friday: "Jumaat",
  Saturday: "Sabtu",
};

const monthMappingBM = {
  // Short
  Jan: "Jan",
  Feb: "Feb",
  Mar: "Mac",
  Apr: "Apr",
  May: "Mei",
  Jun: "Jun",
  Jul: "Jul",
  Aug: "Ogos",
  Sep: "Sep",
  Oct: "Okt",
  Nov: "Nov",
  Dec: "Dis",
  // Full
  January: "Januari",
  February: "Februari",
  March: "Mac",
  April: "April",
  May: "Mei",
  June: "Jun",
  July: "Julai",
  August: "Ogos",
  September: "September",
  October: "Oktober",
  November: "November",
  December: "Disember",
};

class DateLogic {
  /** @deprecated Use toDay(day, language) instead */
  static toMalayDay(englishDay) {
    return dayMappingBM[englishDay] || englishDay;
  }

  /**
   * Returns the day name in the requested language.
   * language: 'BM' → Malay day name, 'EN' → keeps the English day name
   */
  static toDay(englishDay, language) {
    if (String(language || '').toUpperCase() === 'EN') return englishDay;
    return dayMappingBM[englishDay] || englishDay;
  }

  /**
   * Returns the month name in the requested language.
   * language: 'BM' → Malay month name, 'EN' → keeps the English month name
   */
  static toMonth(englishMonth, language) {
    if (String(language || '').toUpperCase() === 'EN') return englishMonth;
    return monthMappingBM[englishMonth] || englishMonth;
  }

  /**
   * Formats a date string or object with translated day/month names.
   * formatStr: e.g. "D MMM YYYY"
   */
  static formatDate(date, formatStr = "D MMM YYYY", language = "BM") {
    if (!date) return "";
    const d = dayjs(date);
    if (!d.isValid()) return "";
    if (String(language || '').toUpperCase() === "EN") return d.format(formatStr);

    let formatted = d.format(formatStr);
    const mmmm = d.format("MMMM");
    const mmm = d.format("MMM");
    const dddd = d.format("dddd");

    if (monthMappingBM[mmmm]) formatted = formatted.replace(mmmm, monthMappingBM[mmmm]);
    if (monthMappingBM[mmm]) formatted = formatted.replace(mmm, monthMappingBM[mmm]);
    if (dayMappingBM[dddd]) formatted = formatted.replace(dddd, dayMappingBM[dddd]);

    return formatted;
  }

  /**
   * Returns Islamic (Hijri) date formatted based on language.
   * e.g. "16 Rejab 1448 H" (BM) or "16 Rajab 1448 AH" (EN)
   */
  static toIslamicDate(date, language = "BM") {
    if (!date) return "";
    try {
      const d = dayjs(date).toDate();
      if (isNaN(d.getTime())) return "";
      const isEnglish = String(language || '').toUpperCase() === 'EN';
      const locale = isEnglish ? 'en-u-ca-islamic-umalqura' : 'ms-u-ca-islamic-umalqura';
      const formatter = new Intl.DateTimeFormat(locale, {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
      const parts = formatter.formatToParts(d);
      const day = parts.find(p => p.type === 'day')?.value;
      const month = parts.find(p => p.type === 'month')?.value;
      const year = parts.find(p => p.type === 'year')?.value;
      const era = parts.find(p => p.type === 'era')?.value || (isEnglish ? 'AH' : 'H');

      if (!day || !month || !year) return formatter.format(d);
      return `${day} ${month} ${year} ${era}`;
    } catch (e) {
      return "";
    }
  }
}

export default DateLogic;
